<div *ngIf="mode === 'topNav'">
  <div *ngIf="primaryFacility" class="d-flex flex-row align-items-center">
    <div class="d-flex flex-row align-items-center">
      <i class="header-icon dx-icon-pharmacies"></i>
      <p class="mb-0 mr-2">Ordering for:</p>
    </div>
    <div
      *ngIf="isRepresentative"
      class="fake-dropdown-container"
      style="border: none"
    >
      <div class="fake-dropdown-facility-name" title="Current Facility">
        <p class="mb-0">{{ primaryFacility.name }}</p>
      </div>
    </div>
    <div
      *ngIf="!isRepresentative"
      class="fake-dropdown-container"
      (click)="openFacilityDialog()"
      data-testid="switch-fac-btn-open-dialog"
    >
      <div class="fake-dropdown-facility-name" title="Change Facility">
        <p class="mb-0">{{ primaryFacility.name }}</p>
      </div>
      <div class="fake-dropdown-button">
        <i class="dx-icon-chevrondown"></i>
      </div>
    </div>
  </div>
</div>

<!-- Portaled to <body> (MDG-106): inside the fixed header toolbar the panel's
     z-index is trapped in the toolbar's stacking context and renders behind
     the past-due banner. Attach/detach is driven by the showFacilityInfo setter. -->
<ng-template cdkPortal>
  <div id="new-theme">
    <div class="facility-panel">
      <div class="top-section">
        <div class="section-row">
          <div class="mb-3 ml-5 bold-font">SHOPPING FOR:</div>
          <div class="mb-3 mr-5">
            <dx-select-box
              class="mb-1"
              [items]="facilitiesList"
              displayExpr="name"
              valueExpr="id"
              placeholder="Select a facility..."
              [showClearButton]="false"
              [value]="primaryFacilityId"
              [disabled]="!canSwitch"
              (onValueChanged)="onFacilityChanged($event)"
              width="225"
              [stylingMode]="'underlined'"
              [elementAttr]="{
                'data-testid': 'switch-fac-select-facility-topnav',
              }"
            >
              <dxo-drop-down-options [width]="'500'"></dxo-drop-down-options>
              <div *dxTemplate="let data of 'field'">
                <div class="custom-item">
                  <dx-text-box
                    class="product-name"
                    [value]="data.name"
                    [readOnly]="true"
                    [stylingMode]="'outlined'"
                  ></dx-text-box>
                </div>
              </div>
              <div *dxTemplate="let data of 'item'">
                {{ data.name }} - {{ data.dea_number }}
              </div>
            </dx-select-box>
          </div>
        </div>
        <div class="section-row">
          <div class="mb-3 ml-5 bold-font">SHIPPING TO:</div>
          <div class="mb-3 mr-5">
            <div *ngIf="deliveryAddress">
              {{ deliveryAddress.line_1 | titlecase }}<br />
              <div *ngIf="deliveryAddress.line_2">
                {{ deliveryAddress.line_2 | titlecase }}
              </div>
              <div *ngIf="deliveryAddress.line_3">
                {{ deliveryAddress.line_3 | titlecase }}
              </div>
              {{ deliveryAddress.city | titlecase }},
              {{ deliveryAddress.state }},
              {{ deliveryAddress.postal_code }}
            </div>
          </div>
        </div>
        <div class="section-row">
          <div class="mb-3 ml-5 bold-font" style="float: left">DEA NUMBER:</div>
          <div class="mb-3 mr-5 dea">
            {{ primaryFacility.dea_number }}
          </div>
        </div>
      </div>
      <div class="bottom-section mr-5 ml-5">
        <div *ngIf="budget.amount && features.budgetsAndSavings">
          <div class="mb-2" *ngIf="budget.amount && budgetEndDate < today">
            <span class="dx-font-xs text-danger">
              {{ budget.target == 'company' ? 'System' : 'Facility' }} Budget
              Expired!
            </span>
          </div>
          <div class="mb-3">
            <div class="bold-font">
              FACILITY BUDGET SPENT: {{ budgetPercentage }}%
            </div>
            <div>
              <div
                class="mb-2"
                *ngIf="savings.amount && savingsEndDate < today"
              >
                <span class="dx-font-xs text-danger">
                  {{ savings.target == 'company' ? 'System' : 'Facility' }}
                  Savings Expired!
                </span>
              </div>
              <div class="mb-2" *ngIf="budget.amount || savings.amount">
                <div *ngIf="budget.amount">
                  <span
                    class="dx-font-xs text-danger"
                    *ngIf="budgetPercentage > 100"
                  >
                    {{ budget.target == 'company' ? 'System' : 'Facility' }}
                    Budget Exceeded!
                  </span>
                  <span
                    class="dx-font-xs text-warning"
                    *ngIf="budgetPercentage == 100"
                  >
                    {{ budget.target == 'company' ? 'System' : 'Facility' }}
                    Budget Met!
                  </span>
                  <dx-bullet
                    class="bullet"
                    color="#73ACF0"
                    targetColor="#FFFFFF"
                    [startScaleValue]="0"
                    [endScaleValue]="budget.amount"
                    [value]="budgetAmountUsed"
                    [target]="budget.amount"
                  >
                    <dxo-tooltip
                      [zIndex]="1000"
                      [customizeTooltip]="customizeBudgetTooltip"
                    ></dxo-tooltip>
                  </dx-bullet>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div *ngIf="savings.amount && features.budgetsAndSavings" class="mb-3">
          <div class="bold-font">
            PHARMACY SAVINGS EARNED: {{ savingsPercentage }}%
          </div>
          <div>
            <div class="mb-2" *ngIf="savings.amount">
              <span
                class="dx-font-xs text-success"
                *ngIf="savingsPercentage > 100"
              >
                {{
                  savings.target == 'company' ? 'System' : 'Facility'
                }}
                Savings Goal Exceeded!
              </span>
              <span
                class="dx-font-xs text-info"
                *ngIf="savingsPercentage == 100"
              >
                {{
                  savings.target == 'company' ? 'System' : 'Facility'
                }}
                Savings Met!
              </span>
              <dx-bullet
                class="bullet"
                color="#73ACF0"
                targetColor="#FFFFFF"
                [startScaleValue]="0"
                [endScaleValue]="savings.amount"
                [value]="savingsAmountUsed"
                [target]="savings.amount"
              >
                <dxo-tooltip
                  [zIndex]="1000"
                  [customizeTooltip]="customizeSavingsTooltip"
                ></dxo-tooltip>
              </dx-bullet>
            </div>
          </div>
        </div>
        <div
          *ngIf="formattedBudgetStart && features.budgetsAndSavings"
          class="bold-font mb-3"
        >
          PERIOD: {{ formattedBudgetStart }} - {{ formattedBudgetEnd }}
        </div>
        <div
          *ngIf="features.budgetsAndSavings"
          class="d-flex align-items-center justify-content-between mb-3"
        >
          <dx-button
            *ngIf="canManageBudget"
            type="default"
            stylingMode="outlined"
            [text]="'Manage Budget'"
            (onClick)="goToBudgetManager()"
            [elementAttr]="{ 'data-testid': 'switch-fac-btn-manage-budget' }"
          ></dx-button>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<!-- Wait for the data source: it exists only after the profile loads, and
     ngOnInit then resets searchText from the URL, dropping earlier typing. -->
<div *ngIf="mode === 'page' && facilitiesDataSource">
  <div class="d-flex justify-content-end mb-2">
    <dx-button
      *ngIf="isSalesRepresentative"
      text="Open territories"
      type="default"
      icon="map"
      [stylingMode]="territoryView === 'open' ? 'contained' : 'outlined'"
      class="mr-2 territory-view-btn"
      hint="Show open territories instead of your own territories"
      (onClick)="onTerritoryViewToggle()"
      [elementAttr]="{ 'data-testid': 'switch-fac-btn-territory-view' }"
    ></dx-button>
    <dx-button
      *ngIf="termsToolsEnabled"
      text="Terms pending"
      type="default"
      icon="filter"
      [stylingMode]="termsPendingOnly ? 'contained' : 'outlined'"
      class="mr-2 terms-pending-btn"
      hint="Show only customers that have not accepted the Terms & Conditions, sorted by order volume (highest first)"
      (onClick)="onTermsPendingToggle()"
      [elementAttr]="{ 'data-testid': 'switch-fac-btn-terms-pending' }"
    ></dx-button>
    <dx-text-box
      placeholder="Search..."
      [(value)]="searchText"
      valueChangeEvent="keyup"
      (onValueChanged)="onSearchChange()"
      [showClearButton]="true"
      [width]="isMobile ? '100%' : '300px'"
      [inputAttr]="{ 'data-testid': 'switch-fac-input-search' }"
    ></dx-text-box>
  </div>

  <dx-list
    [dataSource]="facilitiesDataSource"
    [height]="'auto'"
    [pullRefreshEnabled]="false"
    [activeStateEnabled]="false"
    [focusStateEnabled]="false"
    selectionMode="none"
    pageLoadMode="nextButton"
    itemTemplate="facilityTemplate"
    [elementAttr]="{ 'data-testid': 'switch-fac-list-facilities' }"
  >
    <div *dxTemplate="let facility of 'facilityTemplate'">
      <app-facility-card
        *ngIf="!(!facility.vetted && facility.vetted_date)"
        [facility]="facility"
        [primaryFacilityId]="primaryFacilityId"
        [userId]="profile?.id"
        [isReadOnly]="isReadOnly"
        (switch)="setPrimaryFacility($event)"
      ></app-facility-card>
    </div>
  </dx-list>
</div>

<app-overlay
  *ngIf="showFacilityInfo"
  (closePopup)="showFacilityInfo = !showFacilityInfo"
></app-overlay>
